import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import './Header.css';
import BurgerMenu from './BurgerMenu';
import SunMark from './SunMark';
import LanguageSwitch from './LanguageSwitch';
import { useI18n } from '../i18n/I18nContext';
import { homePath } from '../i18n/paths';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { openModal } = useAppointmentModal();
  const { lang, copy } = useI18n();
  const home = homePath(lang);

  const handleScrollToTop = (e) => {
    e.preventDefault();
    
    if (location.pathname !== home) {
      navigate(home);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleScrollToSection = (sectionId) => (e) => {
    e.preventDefault();
    const hash = sectionId.startsWith('#') ? sectionId : `#${sectionId}`;
    const scroll = () => {
      const element = document.querySelector(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    if (location.pathname !== home) {
      navigate(`${home}${hash}`);
      setTimeout(scroll, 100);
    } else {
      navigate(`${home}${hash}`, { replace: true });
      scroll();
    }
  };

  return (
    <header className="michaela-header">
      <div className="michaela-header-container">
        <Link to={home} className="michaela-header-logo" onClick={handleScrollToTop}>
          <img 
            src="/img/michaela_braun_2.png" 
            alt={copy.home.logoAlt} 
            className="michaela-header-logo-image"
          />
          <SunMark />
        </Link>
        
        <nav className="michaela-header-nav">
          <a href={home} className="michaela-header-nav-link" onClick={handleScrollToTop}>{copy.nav.home}</a>
          <Link to={lang === 'en' ? '/en/about' : '/ueber-mich'} className="michaela-header-nav-link">{copy.nav.about}</Link>
          <Link to={lang === 'en' ? '/en/services' : '/leistungen'} className="michaela-header-nav-link">{copy.nav.services}</Link>
          <a href="#raeume" className="michaela-header-nav-link" onClick={handleScrollToSection('#raeume')}>{copy.nav.approach}</a>
          <Link to={lang === 'en' ? '/en/insights' : '/impulse'} className="michaela-header-nav-link">{copy.nav.insights}</Link>
          <Link to={lang === 'en' ? '/en/testimonials' : '/stimmen'} className="michaela-header-nav-link">{copy.nav.testimonials}</Link>
          <Link to={lang === 'en' ? '/en/contact' : '/kontakt'} className="michaela-header-nav-link">{copy.nav.contact}</Link>
          <button 
            onClick={(e) => {
              e.preventDefault();
              openModal();
            }}
            className={`michaela-header-nav-link michaela-header-nav-link-special${lang === 'en' ? ' is-en' : ''}`}
          >
            {copy.nav.cta}
          </button>
        </nav>
        <div className="michaela-header-tools">
          <LanguageSwitch className="michaela-lang-switch-header" />
          <BurgerMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;

